import { getRouterLocaleInfo } from './getRouterLocaleInfo'
import { getDefaultLocale } from './getDefaultLocale'

/**
 * Convert the locale used in the Next router to a real locale code
 * Note: the NextJs locale, the one that we can get from the router (useRouter) or as a part
 * of the getStaticProps context - if the "locale" part of the URL (the root level URL path part).
 * These locales do not necessarily match real valid ISO locales.
 * On the other hand, when we store/load translations, we want to identify them by valid ISO codes.
 * So, routerLocaleInfo JSON is a mapping between root level URL path and the corresponding ISO locale.
 *
 * @param locale
 */
export const mapRouterLocaleToReal = (locale?: string): string => {
    const routerLocaleInfo = getRouterLocaleInfo()
    const defaultLocale = getDefaultLocale()
    if (!routerLocaleInfo) {
        return locale ?? defaultLocale
    }
    if (!locale) {
        return routerLocaleInfo[defaultLocale].locale
    }
    // Handle the case when locale is not defined in the mapping (likely, it is mapped already)
    return routerLocaleInfo[locale.toLocaleLowerCase()]?.locale ?? locale
}
